import { useLocation } from 'react-router-dom';

/**
 * Reads `multiplexBuildingSessionId` from the current URL query string (React Router).
 *
 * @returns {{ multiplexBuildingSessionId: string | null }}
 */
const useMultiplexBuildingSessionId = () => {
  const { search } = useLocation();

  const multiplexBuildingSessionId = new URLSearchParams(search).get('multiplexBuildingSessionId');

  return { multiplexBuildingSessionId };
};

export default useMultiplexBuildingSessionId;
